// PageTitle.js
// Sets a unique, descriptive document.title per route (WCAG 2.4.2 — audit item G2).
// Central map keyed by pathname; falls back to the plain brand name.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BRAND = 'RightSpade';

const TITLES = {
    '/':                          'Home',
    '/login':                     'Login',
    '/register':                  'Register',
    '/forgot-password':           'Forgot Password',
    '/query':                     'Query',
    '/contact':                   'About Us', // nav labels this page "About" (docx round-2)
    '/compliance':                'Compliance',
    '/legal':                     'Legal',
    '/logout':                    'Logout',
    '/admin':                     'Admin',
    '/admin/complaints':          'Admin Complaints',
    '/dashboard/reports':         'Reports',
    '/dashboard/market-overview': 'Market Overview',
    '/dashboard/ai-assistant':    'AI Assistant',
    '/dashboard/market-wrap':     'Market Wrap',
    '/dashboard/portfolio':       'Portfolio',
    '/dashboard/compliance':      'Compliance',
    '/dashboard/admin':           'Admin',
};

const PageTitle = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const path = pathname.replace(/\/+$/, '') || '/';
        const page = TITLES[path];
        document.title = page ? `${page} | ${BRAND}` : BRAND;
    }, [pathname]);

    return null;
};

export default PageTitle;
